import { motion, AnimatePresence } from "framer-motion";
import { Check } from "lucide-react";

interface SaveFeedbackProps {
  show: boolean;
}

export const SaveFeedback = ({ show }: SaveFeedbackProps) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          className="fixed inset-0 flex items-center justify-center pointer-events-none z-50"
        >
          <div className="bg-green-500 text-white rounded-full p-6 shadow-lg">
            <Check className="w-12 h-12" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
